/**
 * Parse the inspector route segment (`:fp_code`) into `{ ref, fpCode }`.
 *
 * Pages MUST call data APIs with the bare `fpCode` (endpoints resolve by
 * `fp_code`; the raw `-a` segment would 404). The raw `ref` is kept only for
 * building within-FP nav links that preserve the `-a` form.
 */
import { useParams } from 'react-router-dom'
import { parseInspectorRef } from '../utils/urls'

export interface InspectorRouteRef {
  /** Raw route segment, e.g. `'aupsc'` or `'aupsc-a'`. */
  ref: string
  /** Bare franchise code - use this for all data API calls. */
  fpCode: string
  /** Dormant in Stage 1 (never populated); removed with the Stage-2 rename. */
  tenureId?: number
}

export function useInspectorRef(): InspectorRouteRef {
  const { fp_code } = useParams<{ fp_code?: string }>()
  const { fpCode, tenureId } = parseInspectorRef(fp_code)
  return { ref: fp_code ?? '', fpCode, tenureId }
}
